import { DateRange } from '../../models/date-range/date-range.model';
import { addYears, Duration, endOfDay, startOfDay, subDays } from 'date-fns';
import { add as dateFnsAdd } from 'date-fns/add';

export function createRangeFromDuration(
  datePoint: Date | string,
  duration: Duration | 'infinite',
): DateRange {
  if (duration === 'infinite') {
    return new DateRange(startOfDay(datePoint), addYears(datePoint, 200), true, true);
  }
  const endDate: Date = subDays(dateFnsAdd(datePoint, duration), 1);
  return new DateRange(startOfDay(datePoint), endOfDay(endDate), true, true);
}
